import { ConsultaOftalmologicaData } from '../interfaces/consultaOftalmologica.interface'

export type ConsultaOftalmologicaFormData = ConsultaOftalmologicaData

export const getInitialData = (
  initialData?: Partial<ConsultaOftalmologicaData>
): ConsultaOftalmologicaFormData => {
  return {
    id_paciente: initialData?.id_paciente ?? 0,
    semCorrecaoOdEsf: initialData?.semCorrecaoOdEsf ?? '',
    semCorrecaoOdCil: initialData?.semCorrecaoOdCil ?? '',
    semCorrecaoOeEsf: initialData?.semCorrecaoOeEsf ?? '',
    semCorrecaoOeCil: initialData?.semCorrecaoOeCil ?? '',
    comCorrecaoOdEsf: initialData?.comCorrecaoOdEsf ?? '',
    comCorrecaoOdCil: initialData?.comCorrecaoOdCil ?? '',
    comCorrecaoOeEsf: initialData?.comCorrecaoOeEsf ?? '',
    comCorrecaoOeCil: initialData?.comCorrecaoOeCil ?? '',
    pioOd: initialData?.pioOd ?? '',
    pioOe: initialData?.pioOe ?? '',
    biomicroscopiaOd: initialData?.biomicroscopiaOd ?? '',
    biomicroscopiaOe: initialData?.biomicroscopiaOe ?? '',
    gonioscopia: initialData?.gonioscopia ?? '',
    fundoscopiaOd: initialData?.fundoscopiaOd ?? '',
    fundoscopiaOe: initialData?.fundoscopiaOe ?? '',
    tonometriaAplanacaoOd: initialData?.tonometriaAplanacaoOd ?? '',
    tonometriaAplanacaoOe: initialData?.tonometriaAplanacaoOe ?? '',
    campoVisualOd: initialData?.campoVisualOd ?? '',
    campoVisualOe: initialData?.campoVisualOe ?? '',
    limitacaoCognitiva: initialData?.limitacaoCognitiva ?? false,
    limitacaoLocomocao: initialData?.limitacaoLocomocao ?? false,
    limitacaoVisao: initialData?.limitacaoVisao ?? false,
    limitacaoAudicao: initialData?.limitacaoAudicao ?? false,
    outros: initialData?.outros ?? '',
    alergia: initialData?.alergia ?? '',
    historicoBaixaVisao: initialData?.historicoBaixaVisao ?? '',
    realizaTratamento: initialData?.realizaTratamento ?? false,
    qualTratamento: initialData?.qualTratamento ?? '',
    medicamentosUtiliza: initialData?.medicamentosUtiliza ?? '',
    acompanhamentoOftalmologico: initialData?.acompanhamentoOftalmologico ?? '',
    observacoes: initialData?.observacoes ?? '',
    status_atendimento: initialData?.status_atendimento ?? ''
  }
}
